import gql from "graphql-tag";

const DELETE_SERVICEPERFORMED_MUTATION = gql`
  mutation DeleteServicePerformed($id: Int!) {
    deleteServicePerformed(id: $id)
  }
`;

export default DELETE_SERVICEPERFORMED_MUTATION;
